import { ErrorOutline as ErrorOutlineIcon } from 'components/icons';
import { buttonStyle } from 'components/buttons/buttonStyle';
import { Button } from 'components/ui/button';
import { useRouteError } from 'react-router-dom';

const RouteErrorPage = () => {
    const error = useRouteError();

    const message = error instanceof Error ? error.message : 'An unexpected error occurred';
    const stack = error instanceof Error ? error.stack : undefined;
    const isDev = import.meta.env.DEV;

    return (
        <div className="flex grow flex-col items-center justify-center px-6 py-12 text-center">
            <ErrorOutlineIcon className="text-error mb-4 text-[56px]" />

            <h5 className="text-h5 mb-3 text-balance">Something went wrong</h5>

            <p className="text-body1 text-fg-secondary mb-6 max-w-[480px]">
                An unexpected error occurred. Please try again or return to the home page.
            </p>

            <div className="flex gap-4">
                <Button {...buttonStyle({ variant: 'outlined' })} onClick={() => window.location.reload()}>
                    Reload page
                </Button>
                <Button
                    {...buttonStyle({ variant: 'contained' })}
                    nativeButton={false}
                    role="link"
                    render={<a href="/home" />}
                >
                    Go to Home
                </Button>
            </div>

            {isDev && stack && (
                <pre className="bg-grey-100 mt-8 w-full max-w-[720px] overflow-auto rounded-[4px] p-4 text-left text-[12px]">
                    {message}
                    {'\n\n'}
                    {stack}
                </pre>
            )}
        </div>
    );
};

export default RouteErrorPage;
